import React from 'react';
import { FileIcon } from '@revfluence/fresh-icons/solid/esm';
import { Badge } from '@/shadcn/components/ui/badge';
import { ApplicationField } from '../../adapters/application-tab/member-application-fields-adapter';

interface FormFieldsSectionProps {
  fields: ApplicationField[];
}

export const FormFieldsSection: React.FC<FormFieldsSectionProps> = ({
  fields,
}) => {
  const renderFieldValue = (field: ApplicationField) => {
    if (!field.value) {
      return <div className="text-grey-5 text-sm">--</div>;
    }

    if (field.type === 'file') {
      return (
        <Badge
          variant="secondary"
          className="px-2 py-0.5 bg-grey-2 rounded-lg inline-flex items-center gap-1"
        >
          <FileIcon className="w-3 h-3 text-grey-6" />
          <span className="text-grey-6 text-xs font-normal">
            {field.value}
          </span>
        </Badge>
      );
    }

    return (
      <div className="text-grey-6 text-sm font-normal">
        {field.value}
      </div>
    );
  };

  const renderFileUploadField = () => {
    // Check if we have a file field with a value
    const fileField = fields.find((field) => field.type === 'file' && field.value);

    if (!fileField) return null;

    return (
      <div className="flex flex-col gap-1">
        <div className="text-grey-6 text-xs font-medium">
          Upload File
        </div>
        <Badge
          variant="secondary"
          className="px-2 py-0.5 bg-grey-2 rounded-lg inline-flex items-center gap-1 w-fit"
        >
          <FileIcon className="w-3 h-3 text-grey-6" />
          <span className="text-grey-6 text-xs font-normal">
            {fileField.value}
          </span>
        </Badge>
      </div>
    );
  };

  // Filter out file fields from main list since we handle them separately
  const nonFileFields = fields.filter((field) => field.type !== 'file');

  return (
    <div className="p-4 bg-grey-1 rounded-2xl border border-grey-2 flex flex-col gap-4">
      <div className="flex flex-col gap-3">
        {nonFileFields.map((field) => (
          <div
            key={field.id}
            className="px-3 py-1 bg-white rounded-xl border border-grey-3 flex flex-col"
          >
            <div className="flex items-start gap-2">
              <div className="flex-1">
                <span className="text-grey-5 text-xs font-normal">
                  {field.label}
                </span>
                {field.required && (
                  <span className="text-red-500 text-xs font-normal">*</span>
                )}
              </div>
            </div>
            <div className="mt-1">
              {renderFieldValue(field)}
            </div>
          </div>
        ))}

        {renderFileUploadField()}
      </div>
    </div>
  );
};
